import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';

export const ListHeading = styled.p`
  ${ProductiveHeading07};
  font-weight: normal;
  font-size: var(--font-size-sm);
  padding: 0 var(--spacing-05);
  padding-left: var(--left-spacing);
  margin-bottom: var(--spacing-03);
`;

export const ConversationList = styled.div`
  padding-bottom: var(--spacing-06);
  padding-top: var(--spacing-05);
`;

export const Conversations = styled.div`
  overflow-y: hidden;
`;
